/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var menu_dropdown_elements = document.querySelectorAll('.menu-item-has-children');
  if(menu_dropdown_elements) {
    check_dropdown_elements();

    menu_dropdown_elements.forEach((menu_dropdown_element) => {
      menu_dropdown_element.addEventListener('mouseenter', (e) => {
        var dropdown = menu_dropdown_element.querySelector(':scope > .sub-menu-container');
        if(dropdown) {
          dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
        }
      });

      menu_dropdown_element.addEventListener('mouseleave', (e) => {
        var dropdown = menu_dropdown_element.querySelector(':scope > .sub-menu-container');
        if(dropdown) {
          dropdown.style.maxHeight = '0px';
        }
      });
    });

    window.addEventListener('resize', (e) => {
      check_dropdown_elements();
    });
  }

  function check_dropdown_elements() {
    menu_dropdown_elements.forEach((menu_dropdown_element) => {
      var dropdown = menu_dropdown_element.querySelector('.sub-menu-container'),
          rect = menu_dropdown_element.getBoundingClientRect();

      if(dropdown) {
        if((rect.left + dropdown.offsetWidth) > document.body.offsetWidth) {
          dropdown.classList.add('attach-right');
        } else {
          dropdown.classList.remove('attach-right');
        }
      }
    });

    var locations_dropdown_menu = document.querySelector('.page-hero .primary-nav .sub-menu-container.locations-sub-menu');
    if(locations_dropdown_menu) {
      var page_header = document.querySelector('.page-hero header'),
          page_header_pos = page_header.getBoundingClientRect(),
          locations_menu_item = locations_dropdown_menu.previousElementSibling.querySelector('.menu-anchor'),
          locations_menu_item_pos = locations_menu_item.getBoundingClientRect();

      locations_dropdown_menu.style.bottom = (page_header_pos.bottom - locations_menu_item_pos.bottom) + 'px';
    }
  }
}());